<h2 mat-dialog-title>Rechazar llamada</h2>

<mat-dialog-content>
  <p>¿Confirmas que deseas rechazar la justificación de esta llamada?</p>

  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>Motivo (opcional)</mat-label>
    <textarea
      matInput
      [formControl]="reasonControl"
      rows="4"
      placeholder="Indica el motivo del rechazo...">
    </textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancelar</button>
  <button mat-raised-button color="warn" (click)="confirm()">Confirmar</button>
</mat-dialog-actions>
